













































































































// import openWindow from '@/utils/openWindow'
import { Component, Vue } from "vue-property-decorator";

import { Form as ElForm } from "element-ui";
import { register, isExistPhone } from "@/api/users";
import { sMSAuthenticationCode } from "@/api/common";

@Component({
  name: "Register"
})
export default class extends Vue {
  private registerForm = {
    memberName: "",
    password: "",
    repassword: "",
    mobile: "",
    validCode: "" // 验证码
    // imaCode: "" // 图片验证码
  };

  private validCodeInput = {
    phone: "",
    authenticationType: 1
  };

  // 验证码发送后，60秒倒计时后才可再点击
  private validCodeDisabled = false;
  private time = 0;
  private btntxt = "重新发送";
  private loading = false;

  private validatePass = (rule: any, value: string, callback: Function) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.registerForm.password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };

  private registerRules = {
    memberName: [
      { required: true, message: "请输入用户名", trigger: "blur" },
      { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
    ],
    password: [
      { required: true, message: "请输入密码", trigger: "blur" },
      {
        pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,30}$/,
        message:
          "密码为数字，小写字母，大写字母，特殊符号 至少包含三种，长度为 6 - 30位"
      }
    ],
    repassword: [
      { required: true, validator: this.validatePass, trigger: "blur" }
    ],
    mobile: [
      { required: true, message: "请输入手机号", trigger: "blur" },
      {
        pattern: /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/,
        message: "请输入正确手机号"
      }
    ],
    validCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
  };

  // // 图片验证码
  // private getIdentifyingCode(bRefresh: number) {
  //   let identifyCodeSrc = "https://localhost:5001/api/Login/GetImageCode";
  //   if (bRefresh) {
  //     identifyCodeSrc =
  //       "https://localhost:5001/api/Login/GetImageCode?" + Math.random();
  //   }
  //   const objs = document.getElementById("imgIdentifyingCode");
  //   objs.src = identifyCodeSrc;
  // }

  private resetForm() {
    (this.$refs.registerForm as any).resetFields();
  }

  private submitForm() {
    (this.$refs.registerForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await register(this.registerForm)
          .then(() => {
            this.$message({
              message: "注册成功！",
              type: "success"
            });

            this.closeDialog();
            // this.$router
            //   .push({
            //     path: "/"
            //   })
            //   .catch(err => {
            //     console.warn(err);
            //   });
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            return false;
          });

        // Just to simulate the time of the request
        // setTimeout(() => {
        //   this.loading = false;
        // }, 0.5 * 1000);
      } else {
        return false;
      }
    });
  }

  private closeDialog() {
    this.$emit("hidedialog");
  }

  // 手机验证发送验证码
  private sendcode() {
    const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
    if (this.registerForm.mobile === "") {
      this.$message({
        message: "手机号不能为空",
        center: true
      });
      return;
    }
    if (!reg.test(this.registerForm.mobile)) {
      this.$message({
        message: "请输入正确的手机号",
        center: true
      });
    } else {
      this.validCodeInput.phone = this.registerForm.mobile;

      isExistPhone(this.registerForm.mobile).then(res => {
        if (res.data === true) {
          this.$message({
            message: "该手机号已存在",
            center: true
          });
        } else {
          sMSAuthenticationCode(this.validCodeInput).then(() => {
            this.$message({
              message: "发送成功",
              type: "success",
              center: true
            });
          });
          this.time = 60;
          this.validCodeDisabled = true;
          this.timer();
        }
      });
    }
  }

  // 60S倒计时
  private timer() {
    if (this.time > 0) {
      this.time--;
      this.btntxt = this.time + "s后重新获取";
      setTimeout(this.timer, 1000);
    } else {
      this.time = 0;
      this.btntxt = "获取验证码";
      this.validCodeDisabled = false;
    }
  }
}
